import React from "react";

import type { LinkProps } from "next/link";
import Link from "next/link";

import { ENVIRONMENT, type Environment } from "@repo/ui/utils/environment";

export interface EnvLink
  extends
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>,
    Omit<LinkProps, "href"> {
  hrefs: Partial<Record<Environment | "default", string>>;
  children: React.ReactNode;
}

export const EnvLink: React.FC<EnvLink> = ({ hrefs, children, ...props }) => {
  const href = hrefs[ENVIRONMENT] || hrefs.default || "#";

  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
};
